import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @typescript-eslint/no-explicit-any */
import TextField from "@material-ui/core/esm/TextField";
import Autocomplete from "@material-ui/lab/esm/Autocomplete";
import React from 'react';
import Spinner from 'components/Spinner/Spinner';
import objectHasValues from 'utils/general/objectHasValues';
export default function AutocompleteAsync({
  isLoading,
  options,
  optionLabel,
  placeholder,
  name,
  value,
  onChange,
  inputId
}) {
  if (!options) return null;
  const getOptionValue = option => {
    if (!objectHasValues(option)) return '';
    if (typeof optionLabel === 'string') return option[optionLabel];
    return option[optionLabel[0]] || option[optionLabel[1]];
  };
  return /*#__PURE__*/React.createElement(Autocomplete, {
    key: value,
    id: "autocomplete-async",
    options: options,
    loading: isLoading,
    onChange: onChange,
    getOptionLabel: option => getOptionValue(option),
    style: {
      width: 300
    },
    value: value,
    autoHighlight: true,
    renderOption: option => /*#__PURE__*/React.createElement(React.Fragment, null, option && getOptionValue(option)),
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      placeholder: placeholder,
      name: name,
      variant: "outlined",
      InputProps: {
        ...params.InputProps,
        endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(Spinner, {
          isAutocompleteSpinner: true
        }) : null, params.InputProps.endAdornment)
      }
      // eslint-disable-next-line react/jsx-no-duplicate-props
      ,
      inputProps: {
        ...params.inputProps,
        id: inputId
      }
    }))
  });
}
AutocompleteAsync.defaultProps = {
  value: undefined,
  name: null,
  inputId: undefined
};